import { useCallback } from 'react'
import { Modal, Button } from 'antd'
import { TranslationKeys } from '../../Constants/TranslationKeys'
import { renderTranslation } from '../../Helpers/GenericHelpers'
import { toggleSeasonConfirmChangeModal } from '../../Slices/Omnichannel/SeasonRuleSlice'
import {
  resetDiscounts,
  resetPriceListsToCopyTo,
  setActivePriceListToBeCopy,
} from '../../Slices/Omnichannel/DiscountSlice'
import { deleteRule } from '../../Services/Omnichannel/SeasonRuleService'
import { retrieveRule, retrieveSubrule } from '../../Helpers/DiscountHelper'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { useNavigateWrapper } from '../../Helpers/NavigateHelper'
import { resetListingDiscounts } from 'Slices/Omnichannel/SubRuleSlice'

function ConfirmSeasonRuleChangeModal(props) {
  const dispatch = useAppDispatch()
  const navigationWrapper = useNavigateWrapper()
  const language = useAppSelector(state => state.present.language.value)
  const confirmSeasonRuleChangeModal = useAppSelector(state => state.present.seasonRule.confirmSeasonRuleChangeModal)
  const ruleId = useAppSelector(state => state.present.seasonRule.ruleId)
  const seasonRuleList = useAppSelector(state => state.present.seasonRule.seasonRuleList)
  const subRuleId = useAppSelector(state => state.present.subRule.subRuleId)

  const onModalConfirm = useCallback(() => {
    props.onChangeConfirm()
    dispatch(toggleSeasonConfirmChangeModal(false))
  }, [dispatch, props])

  const onModalCancel = useCallback(() => {
    const ruleMatch = subRuleId ? retrieveSubrule(subRuleId, seasonRuleList) : retrieveRule(ruleId, seasonRuleList)

    dispatch(toggleSeasonConfirmChangeModal(false))
    dispatch(setActivePriceListToBeCopy(undefined))
    dispatch(resetPriceListsToCopyTo())
    dispatch(resetDiscounts())
    dispatch(resetListingDiscounts())
    props.onChangeUndo()
    if (ruleMatch && ruleMatch.virtualId) {
      dispatch(deleteRule(ruleMatch, subRuleId, navigationWrapper))
    }
  }, [subRuleId, seasonRuleList, ruleId, dispatch])

  return (
    <Modal
      title={renderTranslation(language, TranslationKeys.confirmChangeModalTitle)}
      open={confirmSeasonRuleChangeModal}
      closable={true}
      onCancel={e => {
        dispatch(toggleSeasonConfirmChangeModal(false))
      }}
      width={400}
      footer={null}
      className={'confirm-change-modal'}
      getContainer={props.bodyref.current}
    >
      <div className='modal-body-text'>{renderTranslation(language, TranslationKeys.confirmChangeModalBody)}</div>
      <div className='modal-body-btn-box'>
        <Button className='btn confirm-btn' onClick={onModalConfirm}>
          {renderTranslation(language, TranslationKeys.confirmChangeModalConfirm)}
        </Button>
        <Button className='btn decline-btn' onClick={onModalCancel}>
          {renderTranslation(language, TranslationKeys.confirmChangeModalCancel)}
        </Button>
      </div>
    </Modal>
  )
}

export default ConfirmSeasonRuleChangeModal
